module.exports = __webpack_public_path__ + "img/tiutext.3f13d7bd.png";